import DashboardFooter from "app/components/dashboard-footer/dashboard-footer";
import DashboardHeader from "app/components/dashboard-header/dashbboard-header";
import DashboardModal from "app/components/dashboard-modal/dashboard-modal";
import DashboardSidebar from "app/components/dashboard-sidebar/dashboard-sidebar";
import { useTheme } from "app/shared";
import TopBgDark from "assets/img/background/bgdark.png";
import { FC, ReactNode, lazy, useState } from "react";
import styles from "./page-wrapper.module.scss";

const Ball109 = lazy(() =>
  import("assets/img/background/ball109.svg").then((module) => ({
    default: module.ReactComponent,
  }))
);
const Ball26 = lazy(() =>
  import("assets/img/background/ball26.svg").then((module) => ({
    default: module.ReactComponent,
  }))
);
const Ball37 = lazy(() =>
  import("assets/img/background/ball37.svg").then((module) => ({
    default: module.ReactComponent,
  }))
);
const Ball52 = lazy(() =>
  import("assets/img/background/ball52.svg").then((module) => ({
    default: module.ReactComponent,
  }))
);
const Ball90 = lazy(() =>
  import("assets/img/background/ball90.svg").then((module) => ({
    default: module.ReactComponent,
  }))
);
const TopBg = lazy(() =>
  import("assets/img/background/headerBg.svg").then((module) => ({
    default: module.ReactComponent,
  }))
);
const FooterBg = lazy(() =>
  import("assets/img/background/footerBg.svg").then((module) => ({
    default: module.ReactComponent,
  }))
);

type PageWrapperProps = {
  children: ReactNode;
};

const PageWrapper: FC<PageWrapperProps> = ({ children }) => {
  const { theme } = useTheme();
  const [modalIsOpen, setRestrictedModal] = useState<boolean>(false);

  const closeModal = () => setRestrictedModal(false);

  return (
    <div
      className={`${styles.dashboard} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      {theme === "dark" ? (
        <img loading="lazy" src={TopBgDark} alt="" className={styles.topBg} />
      ) : (
        <TopBg className={styles.topBg} />
      )}

      <div className={styles.fixedSidebar}>
        <DashboardSidebar />
      </div>

      <div
        className={`${styles.content} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
      >
        <DashboardHeader />

        <div className={styles.main}>{children}</div>

        <DashboardFooter />
      </div>

      {theme === "light" && <FooterBg className={styles.footerBg} />}

      <DashboardModal
        closeModal={closeModal}
        isOpen={modalIsOpen}
        redirectToAlphamind={() => {}}
      />

      {/* <Ball26 className={`${styles.ball} ${styles.ball1}`} />
      <Ball37 className={`${styles.ball} ${styles.ball2}`} />
      <Ball52 className={`${styles.ball} ${styles.ball3}`} />
      <Ball90 className={`${styles.ball} ${styles.ball4}`} /> */}
      {/* <Ball109 className={`${styles.ball} ${styles.ball5}`} /> */}
    </div>
  );
};

export default PageWrapper;
